<template>
    <el-dialog :title="title"
               :visible="showDialog"
               @close="close"
               @open="getData"
               width="80%">
        <div class="form-body" v-loading="loading">
            <div class="row">
                <div class="col-md-12" v-if="payments.length > 0">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha de pago</th>
                                <th>Método de pago <span class="text-danger">*</span></th>
                                <th>Destino <span class="text-danger">*</span></th>
                                <th class="text-center">Moneda</th>
                                <th class="text-right">T.C.</th>
                                <th class="text-right">Monto(PEN)<span class="text-danger">*</span></th>
                                <th class="text-right">Monto(USD)<span class="text-danger">*</span></th>
                                <th class="text-center">¿Pago recibido?</th>
                                <th v-if="external">Imprimir</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, index) in payments" :key="index">
                                <template v-if="row.id">
                                    <td>PAGO-{{ row.id }}</td>
                                    <td>{{ row.date_of_payment }}</td>
                                    <td>{{ row.payment_method_type_description }}</td>
                                    <td>{{ row.destination_description }}</td>
                                    <td class="text-center">{{ row.currency_type_id }}</td>
                                    <td class="text-right">{{ row.exchange_rate_sale }}</td>
                                    <td class="text-right">{{ row.payment_pen }}</td>
                                    <td class="text-right">{{ row.payment_usd }}</td>
                                    <td class="text-center">
                                        <template v-if="row.payment_received === null">
                                            <span class="d-block" v-if="row.reference"><b>Referencia:</b> {{ row.reference }}</span>
                                            <button type="button" v-if="row.filename" class="btn waves-effect waves-light btn-xs btn-primary mb-2  mt-2"
                                                    @click.prevent="clickDownloadFile(row.filename)">
                                                <i class="fas fa-fw fa-file-download"></i>
                                                Descargar voucher
                                            </button>
                                        </template>
                                        <template v-else>
                                            <span class="d-block mb-2 font-bold">{{ row.payment_received_description }}</span>
                                            <template v-if="row.payment_received">
                                                <span class="d-block" v-if="row.reference"><b>Referencia:</b> {{ row.reference }}</span>
                                                <button type="button" v-if="row.filename" class="btn btn-sm btn-primary mb-2  mt-2"
                                                        @click.prevent="clickDownloadFile(row.filename)">
                                                    <i class="fas fa-fw fa-file-download"></i>
                                                    Descargar voucher
                                                </button>
                                            </template>
                                            <template v-else>
                                                <button type="button" class="btn btn-sm btn-primary" @click="showDialogLinkPayment(row)">
                                                    <i class="fas fa-fw fa-link"></i>
                                                    Link de pago
                                                </button>
                                            </template>
                                        </template>
                                    </td>
                                    <td class="series-table-actions text-center" v-if="external">
                                        <button type="button" class="btn waves-effect waves-light btn-xs btn-primary" @click.prevent="clickOptionsPrint()">
                                            <i class="fas fa-file-upload"></i></button>
                                    </td>
                                    <td class="series-table-actions text-right">
                                        <template v-if="permissions.delete_payment">
                                            <button type="button" class="btn waves-effect waves-light btn-xs btn-danger" @click.prevent="clickDelete(row.id)">
                                                Eliminar
                                            </button>
                                        </template>
                                    </td>
                                </template>
                                <template v-else>
                                    <td></td>
                                    <td>
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.date_of_payment}">
                                            <el-date-picker v-model="row.date_of_payment"
                                                            :picker-options="datePayment"
                                                            type="date"
                                                            :clearable="false"
                                                            format="dd/MM/yyyy"
                                                            value-format="yyyy-MM-dd"
                                                            @change="changeDatePayment(index)"></el-date-picker>
                                            <small class="form-control-feedback" v-if="row.errors.date_of_payment"
                                                   v-text="row.errors.date_of_payment[0]"></small>
                                        </div>
                                    </td>
                                    <td>
                                        <x-select v-model="row.payment_method_type_id"
                                                  :options="payment_method_types"
                                                  @input="changePaymentMethodType(index)">
                                        </x-select>
                                    </td>
                                    <td>
                                        <x-select v-model="row.cash_id"
                                                  :options="all_cash"
                                                  v-if="!row.has_bank_account"
                                                  @input="changeCash(index)">
                                        </x-select>
                                        <x-select v-model="row.bank_account_id"
                                                  :options="bank_accounts"
                                                  @input="changeBankAccount(index)"
                                                  v-else>
                                        </x-select>
                                    </td>
                                    <td>
                                        <x-select v-model="row.currency_type_id"
                                                  :options="currency_types">
                                        </x-select>
                                    </td>
                                    <td>{{ row.exchange_rate_sale }}</td>
                                    <td colspan="2">
                                        <div class="form-group mb-0" :class="{'has-danger': row.errors.payment}">
                                            <el-input v-model="row.payment"></el-input>
                                            <small class="form-control-feedback" v-if="row.errors.payment" v-text="row.errors.payment[0]"></small>
                                        </div>
                                    </td>
                                    <td class="row no-gutters px-0">
                                        <div class="col-md-7">
                                            <div class="row no-gutters">
                                                <div class="col-md-3">
                                                    <el-radio class="mb-3 pt-2" v-model="row.payment_received" label="1">SI</el-radio>
                                                    <el-radio v-model="row.payment_received" label="0">NO</el-radio>
                                                </div>
                                                <div class="col-md-9">
                                                    <el-upload
                                                        :data="{'index': index}"
                                                        :headers="headers"
                                                        :multiple="false"
                                                        :on-remove="handleRemove"
                                                        :action="`/finances/payment-file/upload`"
                                                        :show-file-list="true"
                                                        :file-list="fileList"
                                                        :on-success="onSuccess"
                                                        :limit="1"
                                                        :disabled="row.payment_received == '0'"
                                                        class="pb-1">
                                                        <template v-if="row.payment_received == '0'">
                                                            <el-button type="info" class="btn btn-sm">
                                                                <i class="fas fa-fw fa-upload"></i>
                                                                Cargar voucher
                                                            </el-button>
                                                        </template>
                                                        <template v-else>
                                                            <button type="button" class="btn btn-sm btn-primary" slot="trigger">
                                                                <i class="fas fa-fw fa-upload"></i>
                                                                Cargar voucher
                                                            </button>
                                                        </template>
                                                    </el-upload>
                                                    <template v-if="row.payment_received == '1'">
                                                        <el-button type="info" class="btn btn-sm">
                                                            <i class="fas fa-fw fa-link"></i>
                                                            Link de pago
                                                        </el-button>
                                                    </template>
                                                    <template v-else>
                                                        <button type="button" class="btn btn-sm btn-primary" @click="showDialogLinkPayment(row)">
                                                            <i class="fas fa-fw fa-link"></i>
                                                            Link de pago
                                                        </button>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group mb-0" :class="{'has-danger': row.errors.reference}">
                                                <el-input v-model="row.reference" placeholder="Referencia y/o N° Operación"
                                                          :disabled="row.payment_received == '0'"></el-input>
                                                <small class="form-control-feedback" v-if="row.errors.reference" v-text="row.errors.reference[0]"></small>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="series-table-actions text-right px-0">
                                        <button type="button" class="btn waves-effect waves-light btn-sm btn-info" @click.prevent="clickSubmit(index)">
                                            <i class="fa fa-check d-block"></i>
                                        </button>

                                        <button type="button" class="btn waves-effect waves-light btn-sm btn-danger" @click.prevent="clickCancel(index)">
                                            <i class="fa fa-trash d-block"></i>
                                        </button>
                                    </td>
                                </template>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="6" class="text-right">TOTAL PAGADO</td>
                                <td class="text-right">{{ document.total_paid_pen }}</td>
                                <td class="text-right">{{ document.total_paid_usd }}</td>
                            </tr>
                            <tr v-if="document.credit_notes_total">
                                <td colspan="6" class="text-right">TOTAL NOTA CRÉDITO</td>
                                <td class="text-right">{{ document.credit_notes_total }}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">TOTAL A PAGAR</td>
                                <td class="text-right">{{ document.total_pen }}</td>
                                <td class="text-right">{{ document.total_usd }}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">PENDIENTE DE PAGO</td>
                                <td class="text-right">{{ document.total_difference_pen }}</td>
                                <td class="text-right">{{ document.total_difference_usd }}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 text-center pt-2" v-if="showAddButton && (document.total_difference > 0)">
                    <template v-if="permissions.create_payment">
                        <el-button type="primary" icon="el-icon-plus" @click="clickAddRow">Nuevo</el-button>
                    </template>
                </div>
            </div>
        </div>

        <dialog-link-payment :documentPaymentId="documentPayment.id"
                             :currencyTypeId="document.currency_type_id"
                             :exchangeRateSale="document.exchange_rate_sale"
                             :payment="documentPayment.payment"
                             :showDialog.sync="showDialogLink"
                             :documentPayment="documentPayment">
        </dialog-link-payment>

        <document-options
            :recordId="this.documentId"
            :showDialogOptions.sync="showDialogOptions"
            :showClose="showDialogClose"
            :type="this.type"
            :configuration="this.configuration"></document-options>
    </el-dialog>

</template>

<script>

import DialogLinkPayment from './dialog_link_payment'
import DocumentOptions from '../../Finance/unpaid/partials/options'
import XSelect from "../../../../components/Form/XSelect.vue";
import moment from "moment/moment";

export default {
    props: ['showDialog', 'documentId', 'external', 'configuration', 'resource'],
    // mixins: [deletable],
    components: {
        XSelect,
        DialogLinkPayment,
        DocumentOptions
    },
    data() {
        return {
            title: '',
            loading: false,
            payments: [],
            payment_destinations: [],
            headers: headers_token,
            fileList: [],
            payment_method_types: [],
            bank_accounts: [],
            currency_types: [],
            all_cash: [],
            showAddButton: true,
            document: {},
            permissions: {},
            index_file: null,
            documentPayment: {},
            showDialogLink: false,
            showDialogOptions: false,
            showDialogClose: false,
            type: 'document',
            datePayment: {
                disabledDate(time) {
                    return time.getTime() > moment()
                }
            },
        }
    },
    async created() {
        await this.initForm();
        await this.$http.get(`/store/get_payment_tables`)
            .then(response => {
                this.payment_conditions = response.data.payment_conditions
                this.payment_method_types = response.data.payment_method_types
                this.payment_destinations = response.data.payment_destinations
                this.bank_accounts = response.data.bank_accounts
                this.all_cash = response.data.all_cash
                this.currency_types = response.data.currency_types
                this.permissions = response.data.permissions
            })

        this.$eventHub.$on('reloadDataPayments', () => {
            this.getData()
        })
    },
    methods: {
        initForm() {
            this.payments = [];
            this.fileList = [];
            this.showAddButton = true;
        },
        async getData() {
            this.loading = true
            this.initForm()
            await this.$http.get(`/${this.resource}/payment/document/${this.documentId}`)
                .then(response => {
                    this.document = response.data
                    this.title = 'Pagos del comprobante: ' + this.document.number_full
                })
            await this.$http.get(`/${this.resource}/payment/records/${this.documentId}`)
                .then(response => {
                    this.payments = response.data.data
                })
            // this.$eventHub.$emit('reloadDataUnpaid')
            this.loading = false
        },
        getObjectResponse(success, message = null) {
            return {
                success: success,
                message: message,
            }
        },
        validateDataPayment(row) {
            if (!row.payment_destination_id) return this.getObjectResponse(false, 'El campo destino es obligatorio.')
            if (!row.payment_method_type_id) return this.getObjectResponse(false, 'El campo método de pago es obligatorio.')
            if (!row.payment || row.payment <= 0 || isNaN(row.payment)) return this.getObjectResponse(false, 'El campo monto es obligatorio y debe ser mayor que 0.')

            return this.getObjectResponse(true)
        },
        showDialogLinkPayment(row) {
            if (!row.id) {
                const validate_data_payment = this.validateDataPayment(row)
                if (!validate_data_payment.success) return this.$message.error(validate_data_payment.message)
            }
            this.showDialogLink = true
            this.documentPayment = row
            this.documentPayment.document_id = this.documentId
        },
        clickDownloadFile(filename) {
            window.open(`/finances/payment-file/download-file/${filename}/documents`, "_blank");
        },
        onSuccess(response, file, fileList) {
            this.fileList = fileList
            if (response.success) {
                this.index_file = response.data.index
                this.payments[this.index_file].filename = response.data.filename
                this.payments[this.index_file].temp_path = response.data.temp_path
            } else {
                this.cleanFileList()
                this.$message.error(response.message)
            }
        },
        cleanFileList() {
            this.fileList = []
        },
        handleRemove(file, fileList) {
            this.payments[this.index_file].filename = null
            this.payments[this.index_file].temp_path = null
            this.fileList = []
            this.index_file = null
        },
        async clickAddRow() {
            this.loading = true
            this.showAddButton = false
            let _default = this.payment_method_types.find(row => {
                return row.is_default
            })
            let id = _default ? _default.id : '01'
            if (this.cash_payment_metod !== undefined &&
                this.cash_payment_metod[0] !== undefined) {
                id = this.cash_payment_metod[0].id
            }

            this.payments.push({
                id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: id,
                reference: null,
                payment_destination_id: null,
                filename: null,
                temp_path: null,
                payment: parseFloat(this.document.total_difference),
                errors: {},
                loading: false,
                payment_received: '1',
                has_bank_account: false,
                cash_id: null,
                bank_account_id: null,
                currency_type_id: this.document.currency_type_id,
                exchange_rate_sale: 0
            })
            let index = this.payments.length - 1
            await this.changeDatePayment(index)
            this.changePaymentMethodType(index)
            this.loading = false
        },
        clickCancel(index) {
            this.payments.splice(index, 1);
            this.fileList = []
            this.showAddButton = true;
        },
        changePaymentMethodType(index) {
            let payment_method_type = this.payment_method_types.find(row => {
                return row.id === this.payments[index].payment_method_type_id
            })
            let has_bank_account = payment_method_type.has_bank_account
            this.payments[index].has_bank_account = has_bank_account
            if (has_bank_account) {
                if (this.bank_accounts.length > 0) {
                    this.payments[index].cash_id = null
                    this.payments[index].bank_account_id = this.bank_accounts[0].id
                }
            } else {
                if (this.all_cash.length > 0) {
                    this.payments[index].bank_account_id = null
                    this.payments[index].cash_id = this.all_cash[0].id
                }
            }
            this.changeCash(index)
            this.changeBankAccount(index)
        },
        changeCash(index) {
            if (this.payments[index].cash_id !== null) {
                this.payments[index].payment_destination_id = 'cash'
            }
        },
        changeBankAccount(index) {
            if (this.payments[index].bank_account_id !== null) {
                this.payments[index].payment_destination_id = this.payments[index].bank_account_id
            }
        },
        async clickSubmit(index) {
            let payment = this.payments[index].payment;
            // if (this.document.currency_type_id !== this.payments[index].currency_type_id) {
            //     if (this.document.currency_type_id === 'PEN' && this.payments[index].currency_type_id === 'USD') {
            //         payment = payment * parseFloat(this.payments[index].exchange_rate_sale)
            //     } else {
            //         payment = _.round(payment / parseFloat(this.payments[index].exchange_rate_sale), 2)
            //     }
            // }

            if (this.payments[index].currency_type_id === 'PEN') {
                if (payment > parseFloat(this.document.total_difference_pen)) {
                    this.$message.error('El monto ingresado supera al monto pendiente de pago, verifique.');
                    return;
                }
            } else {
                if (payment > parseFloat(this.document.total_difference_usd)) {
                    this.$message.error('El monto ingresado supera al monto pendiente de pago, verifique.');
                    return;
                }
            }


            let form = {
                document_id: this.documentId
            }
            form = Object.assign({}, form, this.payments[index])
            // let form = {
            //     id: this.payments[index].id,
            //     document_id: this.documentId,
            //     date_of_payment: this.payments[index].date_of_payment,
            //     payment_method_type_id: this.payments[index].payment_method_type_id,
            //     payment_destination_id: this.payments[index].payment_destination_id,
            //     reference: this.payments[index].reference,
            //     filename: this.payments[index].filename,
            //     temp_path: this.payments[index].temp_path,
            //     exchange_rate_sale: this.payments[index].exchange_rate_sale,
            //     bank_account_id: this.payments[index].bank_account_id,
            //     currency_type_id: this.payments[index].currency_type_id,
            //     payment: this.payments[index].payment,
            //     payment_received: this.payments[index].payment_received,
            // };
            await this.$http.post(`/${this.resource}/payment`, form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.getData()
                        this.showAddButton = true
                        this.$emit('success')
                        this.$eventHub.$emit('reloadData')
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.payments[index].errors = error.response.data
                    } else {
                        console.log(error);
                        this.$message.error(error.response.data.message)
                    }
                })
        },
        async changeDatePayment(index) {
            this.loading = true
            await this.$http.post(`/store/exchange_search`, {
                'date': this.payments[index].date_of_payment
            })
                .then(response => {
                    this.payments[index].exchange_rate_sale = response.data
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async clickDelete(id) {
            this.$confirm('¿Desea eliminar el registro?', 'Eliminar', {
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                this.loading = true
                await this.$http.delete(`/${this.resource}/payment/${id}`)
                    .then(async () => {
                        await this.getData()
                        this.$eventHub.$emit('reloadData')
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }).catch(error => {
                console.log(error)
            })
        },
        clickDownloadReport(id) {
            window.open(`/${this.resource}/payment/report/${this.documentId}`, '_blank')
        },
        clickPrint(external_id) {
            window.open(`/finances/unpaid/print/${external_id}/document`, '_blank')
        },
        clickOptionsPrint() {
            this.showDialogOptions = true
            this.showDialogClose = true
        },
        close() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
